<script setup>
import { onMounted, watch, ref, nextTick } from "vue";
import Feed from "../components/Feed";
import Loader from "../components/Loader.vue";
import FilterBar from "../components/FilterBar";
import bus from "../utils/eventBus.js";
import { useFilteredFeedStore } from "../utils/store.js";

const store = useFilteredFeedStore();
const feedSection = ref(null);

const scrollToFeed = async () => {
	await nextTick();
	if (feedSection.value) {
		feedSection.value.scrollIntoView({ behavior: "smooth" });
	}
};

onMounted(async () => {
	store.filters = await store.initState();
	store.fetchItems();
});

onMounted(() => {
	bus.on((e) => {
		scrollToFeed();
	});
});
</script>
<template>
	<div>
		<FilterBar />

		<section class="py-24 scroll-mt-[136px] lg:scroll-mt-[160px]" ref="feedSection">
			<div class="container relative min-h-[66vhx]">
				<p v-if="store.isFiltered" class="no-results absolute -mt-12">{{ store.filterMessage }}</p>
				<Feed :items="store.items" />
				<p v-if="store.isLoading" class="absolute top-0">
					<Loader />
				</p>
				<div v-if="!store.items.length" class="no-results">
					<p v-if="!store.isUpdating">{{ store.messageNoResults }}</p>
				</div>
			</div>
		</section>
	</div>
</template>
<style>
.v-enter-active,
.v-leave-active {
	transition: opacity 0.33s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
